import { parseGlobIcon } from '@utils/parse-glob-icon';

export interface Menus {
  path: string;
  name: string;
  key: string;
  target?: string;
  visible?: boolean;
  children?: Menus[];
}

export const menus: Menus[] = [
  {
    path: '/earn',
    name: 'Earn',
    key: 'Earn',
  },
  {
    path: '/swap',
    name: 'Swap',
    key: 'swap',
  },
  {
    path: '/about',
    name: 'About',
    key: 'About',
  },
];
export const getHeaderMenuIcon = parseGlobIcon(
  import.meta.glob('../assets/images/menus/*', {
    eager: true,
    import: 'default',
  }),
);
